import { render } from "./AFlex.vue?vue&type=template&id=34bb33e8"
import script from "./AFlex.vue?vue&type=script&lang=js"
export * from "./AFlex.vue?vue&type=script&lang=js"

import "./AFlex.vue?vue&type=style&index=0&id=34bb33e8&lang=scss"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__